/**
 * The permit questions' option lists and count rule, kept INSIDE this package.
 *
 * This package imports @officehub/shared for TYPES only (erased at build): the tech PWA and the
 * main client's jest cannot resolve shared from this package's dist, so a runtime import breaks
 * client-tech's build and every jest suite that loads the dist (measured on #7539 CI). The server
 * (survey_updateSection) stays the authority; src/__tests__/permitRules.parity.test.ts fails if
 * anything here drifts from shared/src/lib/survey/permitSection.ts.
 */
export const PERMIT_GAS_SERVICE_CHANGES = ['none', 'meter_upgrade', 'new_service'] as const;
export const PERMIT_SEPTIC_OR_SEWER = ['septic', 'sewer'] as const;

/** Same cap the server applies to the planning/HOA note (and every section string). */
export const MAX_PERMIT_NOTE_LENGTH = 2000;

/** The permit fields that hold an alarm count. */
export const PERMIT_COUNT_FIELDS = ['smokeAlarmCount', 'coAlarmCount'] as const;

/** A house never has more alarms than this; anything above is a typo, not a count. */
export const MAX_PERMIT_ALARM_COUNT = 50;

/** Why a typed alarm count cannot be stored, or null when it can. Same wording as the server's. */
export function permitCountError(field: string, value: unknown): string | null {
  const ok = typeof value === 'number' && Number.isInteger(value) && value >= 0 && value <= MAX_PERMIT_ALARM_COUNT;
  return ok ? null : `${field} must be a whole number from 0 to ${MAX_PERMIT_ALARM_COUNT}`;
}
